import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";

import localeIt from '@angular/common/locales/it';

import { BrowserAnimationsModule } from "@angular/platform-browser/animations";

import { AuthHttpInterceptor, AuthModule } from "@auth0/auth0-angular";

import { NavBarComponent } from "./components/navbar/navbar.component";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { LoggerModule, NgxLoggerLevel } from "ngx-logger";

import { HashLocationStrategy, LocationStrategy, PathLocationStrategy, registerLocaleData } from "@angular/common";
import { MessageService } from "primeng/api";
import { DialogService } from "primeng/dynamicdialog";
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from "@angular/common/http";
import {FileUploadModule} from 'primeng/fileupload';

import {
  MissingTranslationHandler,
  TranslateLoader,
  TranslateModule,
} from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { MyMissingTranslationHandler } from "./translation/MyMissingTranslationHandler";
import { CommonModule } from "@angular/common";

import { CSVBoxAngularModule, CSVBoxMethods } from "@csvbox/angular";

import { environment } from '../environments/environment';

//APPLICAZIONE
import { HomeComponent } from "./pages/home/home.component";


//PRIME NG MODULES
import { StyleClassModule } from "primeng/styleclass";
import { ToastModule } from "primeng/toast";
import { TableModule } from "primeng/table";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { TooltipModule } from "primeng/tooltip";
import { InputSwitchModule } from "primeng/inputswitch";
import { ButtonModule } from "primeng/button";
import { InputTextModule } from 'primeng/inputtext';
import { DropdownModule } from 'primeng/dropdown';
import { PasswordModule } from 'primeng/password';
import { CalendarModule } from 'primeng/calendar';
import { InputNumberModule } from 'primeng/inputnumber';
import { DialogModule } from 'primeng/dialog';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { StepsModule } from 'primeng/steps';
import { ChartModule } from 'primeng/chart';
import { KnobModule } from 'primeng/knob';
import { TagModule } from 'primeng/tag';
import { BadgeModule } from 'primeng/badge'; 
import { TabViewModule } from 'primeng/tabview';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { MultiSelectModule } from 'primeng/multiselect';
import { TieredMenuModule } from 'primeng/tieredmenu';
import { SplitButtonModule } from 'primeng/splitbutton';
import { SelectButtonModule } from 'primeng/selectbutton';
import { CheckboxModule } from 'primeng/checkbox';
import { RadioButtonModule } from 'primeng/radiobutton';


import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { VerticalAuthService } from "./auth/auth.service";
import { PageNotFoundComponent } from './pages/errors/page-not-found/page-not-found.component';
import { ServerErrorComponent } from './pages/errors/server-error/server-error.component';
import { UnderConstructionComponent } from './pages/errors/under-construction/under-construction.component';
import { TestEnvironmentFooterComponent } from './components/test-environment-footer/test-environment-footer.component';
import { RemoveCommaPipe } from "./pipes/removeCommaPipe";

import { AngularFirestoreModule } from '@angular/fire/compat/firestore';
import { AngularFireModule } from '@angular/fire/compat';
import { DialogCreaUtente, DialogModificaAziendaUtente, DialogModificaRuoloUtente, DialogModificaUtente, UtentiComponent } from "./pages/utenti/utenti.component";
import { DialogCreaImpresa, DialogModificaImpresa, ImpreseComponent } from "./pages/imprese/imprese.component";
import { DialogCreaCentrale, DialogModificaCentrale, CentraliComponent, DialogPosizioneCentrale } from "./pages/centrali/centrali.component";
import { DialogCaricaFotoRouter, DialogNoteRework, DialogCaricaPlanimetria,DialogPosizioneScuola, DialogSalvaInformazioni, DialogStoricoPratica, PraticheScuolaBando2Component, DialogCaricaNT9, DialogInserisciNoteRework, DialogAssegnaPratica, DialogCompletaPratica, DialogInserisciNoteRespingimentoPratica, DialogModificaPosizione, DialogModificaPratica, 
   DialogCaricaVerbaleFirmato, DialogCaricaPacchettoFirmato, DialogCaricaNT9Firmato, DialogCaricaPacchettiFirmati, DialogCaricaVerbaliFirmati, DialogCaricaPDFPlanimetria, 
   DialogModificaStatoPratica} from "./pages/pratiche/scuola/bando2/pratiche-scuola-bando2.component";
import { DialogCaricaFotoRouterBando1, DialogNoteReworkBando1, DialogCaricaPiantinaBando1,DialogPosizioneScuolaBando1, DialogSalvaInformazioniBando1, DialogStoricoPraticaBando1, PraticheScuolaBando1Component, DialogCaricaNT9Bando1, DialogInserisciNoteReworkBando1, DialogAssegnaPraticaBando1, DialogCompletaPraticaBando1, DialogInserisciNoteRespingimentoPraticaBando1, DialogModificaPosizioneBando1, DialogModificaPraticaBando1, DialogCaricaVerbaleFirmatoBando1, DialogCaricaPacchettoFirmatoBando1, DialogCaricaVerbaliFirmatiBando1, DialogCaricaPacchettiFirmatiBando1, DialogModificaStatoPraticaBando1 } from "./pages/pratiche/scuola/bando1/pratiche-scuola-bando1.component";

import { TimelineModule } from 'primeng/timeline';

import { MenuModule } from "primeng/menu";
import { ChipModule } from 'primeng/chip';

import { LeafletMarkerClusterModule } from "@asymmetrik/ngx-leaflet-markercluster";
import { LeafletModule } from "@asymmetrik/ngx-leaflet";
//import { LeafletDrawModule } from '@asymmetrik/ngx-leaflet-draw';

import { DialogCreaPratica } from "./pages/pratiche/scuola/bando2/crea-pratica-bando2.component";
import { DialogCreaPraticaBando1 } from "./pages/pratiche/scuola/bando1/crea-pratica-bando1.component";
import { DialogRichiediCambioCentrale } from "./pages/pratiche/scuola/bando2/cambio-centrale-bando2.component";
import { NgxFileDropModule } from 'ngx-file-drop';
import { DialogRichiediCambioCentraleBando1 } from "./pages/pratiche/scuola/bando1/cambio-centrale-bando1.component";
import { DialogDisegnaScuola } from "./pages/pratiche/scuola/bando2/disegna-pratica.component";
import { DialogCaricaFotoRouterSanita, DialogPosizioneAccesso, PraticheSanitaComponent } from "./pages/pratiche/sanita/pratiche-sanita.component";
import { DialogAssegnaPraticaSanita } from "./pages/pratiche/sanita/assegna-pratica-sanita";
import { ComuniComponent } from "./pages/comuni/comuni.component";
import { DialogRichiediAggiornamentoCentrale } from "./pages/pratiche/scuola/bando2/aggiornamento-centrale-bando2.component";
import { DialogCreaLavoroPraticaSanita, DialogInserisciInformazioniPraticaSanita, DialogModificaLavoroPraticaSanita, DialogModificaPosizioneAccesso } from "./pages/pratiche/sanita/inserisci-informazioni-pratica-sanita";
import { DialogModificaCodiceInvioPratica } from "./pages/pratiche/scuola/bando2/cambio-codiceInvio-bando2.component";
import { DialogStoricoPraticaSanita } from "./pages/pratiche/sanita/storico-pratica-sanita";
import {  DialogCaricaCMTPianoTecnicoSanita, DialogCreaPianoTecnicoSanita, DialogModificaPianoTecnicoSanita, PianiTecniciSanitaComponent } from "./pages/pratiche/sanita/pianiTecnici/piani-tecnici-sanita.component";
import { DialogRichiediCambioCentralePraticaSanita } from "./pages/pratiche/sanita/cambio-centrale-sanita.component";
import { DialogModificaCodiceInvioPraticaBando1 } from "./pages/pratiche/scuola/bando1/cambio-codiceInvio-bando1.component";
import { DialogCaricaFileAltroBando2 } from "./pages/pratiche/scuola/bando2/carica-file-altro-bando2.component";
import { DialogCaricaFileAltroBando1 } from "./pages/pratiche/scuola/bando1/carica-file-altro-bando1.component";
import { HomeFlowdy2Component } from "./pages/home/home.flowdy2.component";
import { NavBarFlowdy2Component } from "./components/navbar/flowdy2/navbar.flowdy2.component";
import { HomeFase1Flowdy2Component } from "./pages/home/home.fase1.flowdy2.component";
import { HomeProntofibraFlowdy2Component } from "./pages/home/home.prontofibra.flowdy2.component";
import { HomeFase2Flowdy2Component } from "./pages/home/home.fase2.flowdy2.component";
import { HomeFase3Flowdy2Component } from "./pages/home/home.fase3.flowdy2.component";
import { HomeKOFlowdy2Component } from "./pages/home/home.ko.flowdy2.component";
import { HomeDashboardFlowdy2Component } from "./pages/home/home.dashboard.flowdy2.component";
import { HomeFlowdy2WipComponent } from "./pages/home/home.flowdy2.wip.component";

import { LottieModule } from 'ngx-lottie';
import player from 'lottie-web';
import { LoadingComponent } from "./components/loader/loading.component";
import { ODAComponent } from "./pages/contabile/oda/oda.component";
import { ListinoComponent } from "./pages/contabile/listino/listino.component";
import { CreaListinoComponent } from "./pages/contabile/listino/crea/crea-listino";
import { ModificaListinoComponent } from "./pages/contabile/listino/modifica/modifica-listino";
import { ModificaListinoNazionaleComponent } from "./pages/contabile/listino/modifica/modifica-listino-nazionale";
import { AggiungiRegioneComponent } from "./pages/contabile/listino/aggiungi-regione/aggiungi-configurazione";
import { ModificaRegioneComponent } from "./pages/contabile/listino/modifica-regione/modifica-regione";
import { StoricoNazionaleComponent } from "./pages/contabile/listino/storico/storico-nazionale";
import { StoricoListinoComponent } from "./pages/contabile/listino/storico/storico-listino";
import { CreaOdaComponent } from "./pages/contabile/oda/crea/crea-oda";
import { ModificaOdaComponent } from "./pages/contabile/oda/modifica/modifica-oda";
import { FormattaNumeroPipe } from './pipes/formatta-numero.pipe';
import { BEFComponent } from "./pages/contabile/bef/bef.component";
import { EmettiMdpComponent } from "./pages/contabile/bef/emetti-mdp/emetti-mdp";
import { PraticheOdaComponent } from "./pages/contabile/bef/pratiche/pratiche-oda";
import { ComplessivoMDPComponent } from "./pages/contabile/bef/complessivo/complessivo-mdp";
import { RegistraEmComponent } from "./pages/contabile/bef/registra-em/registra-em";
import { PraticheFase1Bando1Component } from "./pages/pratiche/flowdy2/bando1/fase1/fase1.bando1.component";
import { DialogPosizionePraticaFase1 } from "./pages/pratiche/flowdy2/bando1/fase1/posizione/posizione-pratica-fase1.component";
import { DialogEsitoSopralluogoFase1 } from "./pages/pratiche/flowdy2/shared/esito-sopralluogo-fase1/esito-sopralluogo.component";
import { DialogModificaPreventivoFase1 } from "./pages/pratiche/flowdy2/shared/modifica-preventivo/modifica-preventivo.component";
import { DialogCaricaPreventivoFase1 } from "./pages/pratiche/flowdy2/shared/carica-preventivo/carica-preventivo.component";
import { DialogAssegnaOdaFase1 } from "./pages/pratiche/flowdy2/shared/assegna-oda/assegna-oda.component";
import { DialogCaricaDocumentoFase1 } from "./pages/pratiche/flowdy2/shared/carica-documento/carica-documento.component";
import { DialogRifiutaPreventivoFase1 } from "./pages/pratiche/flowdy2/shared/rifiuta-preventivo/rifiuta-preventivo.component";
import { DialogVerificaConsegnaFase1 } from "./pages/pratiche/flowdy2/shared/verifica-consegna-fase1/verifica-consegna.component";
import { DialogNoteReworkFase1 } from "./pages/pratiche/flowdy2/shared/note-rework-fase1/note-rework.component";
import { ComunicaBocciatura } from "./pages/pratiche/flowdy2/shared/comunica-bocciatura/comunica_bocciatura.component";
import { DialogAccettazioneInvioInfratel } from "./pages/pratiche/flowdy2/shared/comunica-accettazione/accettazione.component";
import { StoricoPraticaComponent } from "./pages/pratiche/flowdy2/shared/storico/storico-pratica.component";
import { PraticheFase1Bando2Component } from "./pages/pratiche/flowdy2/bando2/fase1/fase1.bando2.component";
import { StoricoOdaComponent } from "./pages/contabile/oda/storico/storico-oda.component";
import { ProntofibraComponent } from "./pages/pratiche/flowdy2/prontofibra/prontofibra.component";
import { StoricoPFComponent } from "./pages/pratiche/flowdy2/prontofibra/storico/storico-pf.component";
import { DialogInvioInfratel } from "./pages/pratiche/flowdy2/shared/comunica-invio-infratel/invio-infratel.component";
import { DialogModificaPF } from "./pages/pratiche/flowdy2/prontofibra/modifica-stato/modifica_pf.component";
import { PraticheFase2Bando1Component } from "./pages/pratiche/flowdy2/bando1/fase2/fase2.bando1.component";
import { PraticheFase2Bando2Component } from "./pages/pratiche/flowdy2/bando2/fase2/fase2.bando2.component";
import { DialogComunicaDataAppuntamentoFase2 } from "./pages/pratiche/flowdy2/shared/data-appuntamento-fase2/data_appuntamento_fase2.component";
import { DialogComunicaEsitoAppuntamentoFase2 } from "./pages/pratiche/flowdy2/shared/esito-appuntamento-fase2/esito_appuntamento_fase2.component";
import { DialogCaricaFileFase2 } from "./pages/pratiche/flowdy2/shared/carica-file/carica-file.component";
import { DialogCaricaVerbaleFase2 } from "./pages/pratiche/flowdy2/shared/carica-verbale-fase2/carica-verbale_fase2.component";
import { DialogCaricaFoto } from "./pages/pratiche/flowdy2/shared/carica-foto/carica-foto.component";
import { DialogVerificaConsegnaFase2 } from "./pages/pratiche/flowdy2/shared/verifica-consegna-fase2/verifica_consegna_fase2.component";
import { DialogNoteReworkFase2 } from "./pages/pratiche/flowdy2/shared/note-rework-fase2/note-rework.component";
import { DialogCaricaPermessoFase2 } from "./pages/pratiche/flowdy2/shared/carica-permesso/carica-permesso_fase2.component";
import { DialogPresidioTIMRifiutaPratica } from "./pages/pratiche/flowdy2/shared/presidioTIM-rifiuta-pratica/presidioTIM_rifiuta_pratica.component";
import { PraticheFase3Bando1Component } from "./pages/pratiche/flowdy2/bando1/fase3/fase3.bando1.component";
import { PosizioneScuola } from "./pages/pratiche/flowdy2/shared/posizione-scuola/posizione-scuola.component";
import { ModificaPratica } from "./pages/pratiche/flowdy2/shared/modifica-pratica/modifica-pratica.component";
import { DialogInformazioniFase3Bando1 } from "./pages/pratiche/flowdy2/bando1/fase3/inserisci-info/inserisci-info-fase3.component";
import { ModificaPosizioneScuola } from "./pages/pratiche/flowdy2/shared/modifica-posizione-scuola/modifica-posizione-scuola.component";
import { DialogCaricaPacchettoNT9 } from "./pages/pratiche/flowdy2/shared/carica-NT9/carica-nt9.component";
import { DialogCaricaAltriFile } from "./pages/pratiche/flowdy2/shared/carica-altri-file/carica-altri-file.component";
import { DialogVerificaConsegnaFase3 } from "./pages/pratiche/flowdy2/shared/verifica-consegna-fase3/verifica_consegna_fase3.component";
import { ModificaCodiceinvio } from "./pages/pratiche/flowdy2/shared/modifica-codice-invio/modifica-codice_invio.component";
import { CompletaFase3 } from "./pages/pratiche/flowdy2/bando1/fase3/completa-pratica/completa_fase3_pratica.component";
import { DialogCaricaVerbaleFase3Firmato } from "./pages/pratiche/flowdy2/shared/carica-verbale-fase3/carica-verbale_fase3.component";
import { DialogCaricaPacchettoFirmatoFase3 } from "./pages/pratiche/flowdy2/shared/carica-pacchetto-firmato-fase3/carica-pacchetto_firmato_fase3.component";
import { DialogNoteReworkFase3 } from "./pages/pratiche/flowdy2/shared/note-rework-fase3/note-rework_fase3.component";
import { PraticheFase3Bando2Component } from "./pages/pratiche/flowdy2/bando2/fase3/fase3.bando2.component";
import { CompletaFase3Bando2 } from "./pages/pratiche/flowdy2/bando2/fase3/completa-pratica/completa_fase3_pratica.component";
import { DialogInformazioniFase3Bando2 } from "./pages/pratiche/flowdy2/bando2/fase3/inserisci-info/inserisci-info-fase3.component";
import { PraticheKOBando1Component } from "./pages/pratiche/flowdy2/bando1/ko/ko.bando1.component";
import { PraticheKOBando2Component } from "./pages/pratiche/flowdy2/bando2/ko/ko.bando2.component";
import { DialogModificaDateAccettazioneInfratel } from "./pages/pratiche/flowdy2/shared/modifica-date-accettazione/accettazione.component";
import { DialogModificaDataAttivazione } from "./pages/pratiche/flowdy2/shared/modifica-data-attivazione/modifica_data_attivazione.component";
import { DialogModificaDataInstallazioneRouter } from "./pages/pratiche/flowdy2/shared/modifica-data-installazione-router/modifica_data_installazione_router.component";
import { DialogNoteImpresa } from "./pages/pratiche/flowdy2/shared/note-impresa/note-impresa.component";
import { DialogModificaCategoriaKOProntofibra } from "./pages/pratiche/flowdy2/prontofibra/modifica-categoria/modifica_categoria";
import { DialogModificaStato } from "./pages/pratiche/flowdy2/shared/modifica-stato/modifica_stato.component";
import { DialogComunicaDataSopralluogoFase1 } from "./pages/pratiche/flowdy2/shared/data-sopralluogo-fase1/data_sopralluogo_fase1.component";
import { CardModule } from 'primeng/card';
import { HomeSopralluoghiFlowdy2Component } from "./pages/home/home.sopralluoghi.flowdy2.component";
import { StoricoNotePraticaComponent } from "./pages/pratiche/flowdy2/shared/note-pratica/note-pratica.component";
import { CreaNotaPraticaComponent } from "./pages/pratiche/flowdy2/shared/crea-note-pratica/crea-nota-pratica.component";
import { HomeAppuntamentiFlowdy2Component } from "./pages/home/home.appuntamenti.flowdy2.component";
import { DialogModificaVincolo } from "./pages/pratiche/flowdy2/shared/modifica-vincolo/modifica_vincolo";
import { DialogRichiediCambioCentraleFlowdy2 } from "./pages/pratiche/flowdy2/shared/cambio-centrale/cambio-centrale-bando1.component";
import { DialogCaricaPlanimetriaFase3 } from "./pages/pratiche/flowdy2/bando2/fase3/carica-planimetria/carica-planimetria_fase3.component";
import { HomeFlowdy2DocsModule } from './pages/home/home.flowdy2.docs.module';
import { HomeFlowdy2OverallComponent } from "./pages/home/home.flowdy2.overall.component";
import { DialogCaricaCodiceBarre } from "./pages/pratiche/flowdy2/shared/carica-codice-barre/carica-codice-barre.component";
import { StatoScorteComponent } from './pages/magazzino/stato-scorte/stato-scorte.component';
import { StatoMovimentazioniComponent } from './pages/magazzino/stato-movimentazioni/stato-movimentazioni.component';
import {AnagraficaMagazziniComponent} from "./pages/magazzino/anagrafica-magazzini/anagrafica-magazzini.component";
import { MagazzinoEditCreateDialogComponent } from './pages/magazzino/anagrafica-magazzini/magazzino-edit-create-dialog/magazzino-edit-create-dialog.component';
import {DividerModule} from "primeng/divider";
import { MovimentazioneEditCreateDialogComponent } from './pages/magazzino/stato-movimentazioni/movimentazione-edit-create-dialog/movimentazione-edit-create-dialog.component';
import { MovimentazioneTransferDialogComponent } from './pages/magazzino/stato-movimentazioni/movimentazione-transfer-dialog/movimentazione-transfer-dialog.component';
import { DashboardGlobalComponent } from './pages/magazzino/dashboard-global/dashboard-global.component';
import { InconsistencyReportDialogComponent } from './pages/magazzino/stato-movimentazioni/inconsistency-report-dialog/inconsistency-report-dialog.component';
import { DialogNt9AvvisoComponent } from './pages/utenti/dialog-nt9-avviso.component';
import { DialogCaricaVerbaleWifiFase3 } from "./pages/pratiche/flowdy2/shared/carica-verbale-wifi/carica-verbale_wifi_fase3.component";
import { InconsistencyResolutionDialogComponent } from './pages/magazzino/stato-movimentazioni/inconsistency-resolution-dialog/inconsistency-resolution-dialog.component';
import { MovimentazioneAnnullamentoDialogComponent } from './pages/magazzino/stato-movimentazioni/movimentazione-annullamento-dialog/movimentazione-annullamento-dialog.component';
import { StatoScorteScuoleComponent } from './pages/magazzino/stato-scorte-scuole/stato-scorte-scuole.component';
import {MovimentazioniCaricamentoDialogComponent} from "./pages/magazzino/stato-movimentazioni/movimentazioni-caricamento-dialog/movimentazioni-caricamento-dialog.component";
import {OverlayPanelModule} from "primeng/overlaypanel";
import { DialogCaricaAltriFileFase2 } from "./pages/pratiche/flowdy2/shared/carica-altri-file-fase2/carica-altri-file.component";
import { DialogProgettaPraticaComponent } from "./pages/pratiche/flowdy2/shared/progretta-pratica/progetta-pratica.component";

export function playerFactory() {
  return player;
}
registerLocaleData(localeIt);

@NgModule({
  declarations: [
    AppComponent,
    //COMPONENTI APPLICAZIONE
    LoadingComponent,
    NavBarComponent,
    NavBarFlowdy2Component,
    HomeComponent,
    HomeDashboardFlowdy2Component,
    HomeFlowdy2Component,
    HomeFase1Flowdy2Component,
    HomeProntofibraFlowdy2Component,
    HomeFase2Flowdy2Component,
    HomeFase3Flowdy2Component,
    HomeKOFlowdy2Component,
    HomeSopralluoghiFlowdy2Component,
    PraticheFase1Bando1Component,
    PraticheFase1Bando2Component,
    PraticheFase2Bando1Component,
    PraticheFase3Bando1Component,
    PraticheFase2Bando2Component,
    ProntofibraComponent,
    StoricoPFComponent,
    DialogPosizionePraticaFase1,
    DialogEsitoSopralluogoFase1,
    DialogModificaPreventivoFase1,
    DialogCaricaPreventivoFase1,
    DialogAssegnaOdaFase1,
    DialogCaricaDocumentoFase1,
    DialogRifiutaPreventivoFase1,
    DialogVerificaConsegnaFase1,
    DialogNoteReworkFase1,
    ComunicaBocciatura,
    DialogAccettazioneInvioInfratel,
    StoricoPraticaComponent,
    StoricoOdaComponent,
    DialogInvioInfratel,
    DialogModificaPF,
    DialogComunicaDataAppuntamentoFase2,
    DialogComunicaEsitoAppuntamentoFase2,
    ODAComponent,
    BEFComponent,
    EmettiMdpComponent,
    RegistraEmComponent,
    PraticheOdaComponent,
    ComplessivoMDPComponent,
    ListinoComponent,
    CreaListinoComponent,
    ModificaListinoComponent,
    ModificaListinoNazionaleComponent,
    AggiungiRegioneComponent,
    ModificaRegioneComponent,
    StoricoNazionaleComponent,
    StoricoListinoComponent,
    CreaOdaComponent,
    ModificaOdaComponent,
    UtentiComponent,
    DialogModificaUtente,
    DialogModificaRuoloUtente,
    DialogModificaAziendaUtente,
    DialogCreaUtente,
    ImpreseComponent,
    DialogCreaCentrale, 
    DialogModificaCentrale, 
    CentraliComponent,
    ComuniComponent,
    DialogPosizioneCentrale,
    DialogCreaImpresa,
    DialogModificaImpresa,
    PraticheScuolaBando2Component,
    PraticheScuolaBando1Component,
    PianiTecniciSanitaComponent,
    DialogCreaPianoTecnicoSanita,
    DialogModificaPianoTecnicoSanita,
    PraticheSanitaComponent,
    DialogModificaPratica,
    DialogModificaPraticaBando1,
    DialogSalvaInformazioni,
    DialogSalvaInformazioniBando1,
    DialogCaricaFotoRouter,
    DialogCaricaFotoRouterBando1,
    DialogCaricaPDFPlanimetria,
    DialogRichiediAggiornamentoCentrale,
    DialogCaricaPlanimetria,
    DialogCaricaPiantinaBando1,
    DialogNoteRework,
    DialogNoteReworkBando1,
    DialogPosizioneScuola,
    DialogPosizioneScuolaBando1,
    DialogStoricoPratica,
    DialogStoricoPraticaBando1,
    DialogNoteRework,
    DialogNoteReworkBando1,
    DialogCaricaNT9,
    DialogCaricaNT9Bando1,
    DialogInserisciNoteRework,
    DialogInserisciNoteReworkBando1,
    DialogAssegnaPratica,
    DialogAssegnaPraticaBando1,
    DialogCompletaPratica,
    DialogCompletaPraticaBando1,
    DialogModificaPosizione,
    DialogModificaPosizioneBando1,
    DialogCreaPratica,
    DialogCreaPraticaBando1,
    DialogInserisciNoteRespingimentoPratica,
    DialogInserisciNoteRespingimentoPraticaBando1,
    DialogDisegnaScuola,
    DialogRichiediCambioCentrale,
    DialogCaricaVerbaleFirmato,
    DialogCaricaPacchettoFirmato,
    DialogCaricaPacchettiFirmati,
    DialogRichiediCambioCentraleBando1,
    DialogCaricaVerbaleFirmatoBando1,
    DialogCaricaPacchettoFirmatoBando1,
    DialogCaricaNT9Firmato,
    DialogCaricaVerbaliFirmati,
    DialogCaricaVerbaliFirmatiBando1,
    DialogCaricaPacchettiFirmatiBando1,
    DialogAssegnaPraticaSanita,
    DialogInserisciInformazioniPraticaSanita,
    DialogModificaPosizioneAccesso,
    DialogModificaCodiceInvioPratica,
    DialogPosizioneAccesso,
    DialogCaricaFotoRouterSanita,
    DialogStoricoPraticaSanita,
    DialogCreaLavoroPraticaSanita,
    DialogModificaLavoroPraticaSanita,
    DialogCaricaCMTPianoTecnicoSanita,
    DialogRichiediCambioCentralePraticaSanita,
    DialogModificaCodiceInvioPraticaBando1,
    PageNotFoundComponent,
    ServerErrorComponent,
    UnderConstructionComponent,
    TestEnvironmentFooterComponent,
    DialogModificaStatoPratica,
    DialogModificaStatoPraticaBando1,
    DialogCaricaFileAltroBando2,
    DialogCaricaFileAltroBando1,
    DialogCaricaFileFase2,
    DialogCaricaVerbaleFase2,
    DialogCaricaFoto,
    DialogVerificaConsegnaFase2,
    DialogCaricaPermessoFase2,
    DialogNoteReworkFase2,
    DialogPresidioTIMRifiutaPratica,
    PosizioneScuola,
    ModificaPratica,
    DialogInformazioniFase3Bando1,
    ModificaPosizioneScuola,
    DialogCaricaPacchettoNT9,
    DialogCaricaAltriFile,
    DialogVerificaConsegnaFase3,
    ModificaCodiceinvio,
    CompletaFase3,
    DialogCaricaVerbaleFase3Firmato,
    DialogCaricaPacchettoFirmatoFase3,
    DialogNoteReworkFase3,
    PraticheFase3Bando2Component,
    DialogInformazioniFase3Bando2,
    CompletaFase3Bando2,
    RemoveCommaPipe,
    PraticheKOBando1Component,
    PraticheKOBando2Component,
    DialogModificaDateAccettazioneInfratel,
    DialogModificaDataAttivazione,
    DialogModificaDataInstallazioneRouter,
    DialogNoteImpresa,
    DialogModificaCategoriaKOProntofibra,
    DialogModificaStato,
    DialogComunicaDataSopralluogoFase1,
    StoricoNotePraticaComponent,
    CreaNotaPraticaComponent,
    HomeAppuntamentiFlowdy2Component,
    DialogModificaVincolo,
    DialogRichiediCambioCentraleFlowdy2,
    DialogCaricaPlanimetriaFase3,
    FormattaNumeroPipe,
    HomeFlowdy2WipComponent,
    HomeFlowdy2OverallComponent,
    DialogCaricaCodiceBarre,
    StatoScorteComponent,
    StatoMovimentazioniComponent,
    AnagraficaMagazziniComponent,
    MagazzinoEditCreateDialogComponent,
    MovimentazioneEditCreateDialogComponent,
    MovimentazioneTransferDialogComponent,
    DashboardGlobalComponent,
    InconsistencyReportDialogComponent,
    DialogCaricaCodiceBarre,
    DialogCaricaVerbaleWifiFase3,
    InconsistencyResolutionDialogComponent,
    MovimentazioneAnnullamentoDialogComponent,
    StatoScorteScuoleComponent,
    MovimentazioniCaricamentoDialogComponent,
    DialogCaricaAltriFileFase2,
    DialogProgettaPraticaComponent,
  ],
	imports: [
		BrowserModule,
		AppRoutingModule,
		StyleClassModule,
		BrowserAnimationsModule,
		FormsModule,
		ReactiveFormsModule,
		NgxFileDropModule,
		//LEAFLET
		LeafletModule,
		LeafletMarkerClusterModule,
		//  LeafletDrawModule,
		//MODULI PRIMENG
		ButtonModule,
		TableModule,
		ConfirmDialogModule,
		ToastModule,
		TooltipModule,
		InputSwitchModule,
		InputTextModule,
		DropdownModule,
		PasswordModule,
		CalendarModule,
		InputNumberModule,
		DialogModule,
		InputTextareaModule,
		FileUploadModule,
		ProgressSpinnerModule,
		ToggleButtonModule,
		StepsModule,
		ChartModule,
		KnobModule,
		BadgeModule,
		ChipModule,
		MenuModule,
		TabViewModule,
		TieredMenuModule,
		HttpClientModule,
		CommonModule,
		TagModule,
		MultiSelectModule,
		AutoCompleteModule,
		TimelineModule,
		SplitButtonModule,
		SelectButtonModule,
		CheckboxModule,
		RadioButtonModule,
		CSVBoxAngularModule,
		CardModule,
		AngularFireModule.initializeApp(environment.firebase),
		LoggerModule.forRoot({
			level: NgxLoggerLevel.TRACE,
			serverLogLevel: NgxLoggerLevel.ERROR,
			disableConsoleLogging: false,
		}),
		AuthModule.forRoot({
			domain: environment.auth0.domain,
			clientId: environment.auth0.clientId,
			authorizationParams: {
				redirect_uri: window.location.origin,
				audience: environment.auth0.audience,
			},
			httpInterceptor: {
				allowedList: [
					`${environment.apiUrl}` + "utente",
					`${environment.apiUrl}` + "utente/*",
					`${environment.apiUrl}` + "azienda",
					`${environment.apiUrl}` + "azienda/*",
					`${environment.apiUrl}` + "comune",
					`${environment.apiUrl}` + "centrale",
					`${environment.apiUrl}` + "centrale/*",
					`${environment.apiUrl}` + "listino",
					`${environment.apiUrl}` + "listino/*",
					`${environment.apiUrl}` + "oda",
					`${environment.apiUrl}` + "oda/*",
					`${environment.apiUrl}` + "mdp",
					`${environment.apiUrl}` + "mdp/*",
					`${environment.apiUrl}` + "em",
					`${environment.apiUrl}` + "em/*",
					`${environment.apiUrl}` + "pratica",
					`${environment.apiUrl}` + "pratica/*",
					`${environment.apiUrl}` + "prontofibra",
					`${environment.apiUrl}` + "prontofibra/*",
					`${environment.apiUrl}` + "pratica-scuola",
					`${environment.apiUrl}` + "pratica-scuola/*",
					`${environment.apiUrl}` + "scuola",
					`${environment.apiUrl}` + "scuola/*",
					`${environment.apiUrl}` + "storico-pratica-scuola",
					`${environment.apiUrl}` + "storico-pratica-scuola/*",
					`${environment.apiUrl}` + "nota-pratica-scuola",
					`${environment.apiUrl}` + "nota-pratica-scuola/*",
					`${environment.apiUrl}` + "pratica-sanita",
					`${environment.apiUrl}` + "pratica-sanita/*",
					`${environment.apiUrl}` + "storico-pratica-sanita",
					`${environment.apiUrl}` + "lavori-pratica-sanita",
					`${environment.apiUrl}` + "storico-pratica-sanita/*",
					`${environment.apiUrl}` + "lavori-pratica-sanita/*",
					`${environment.apiUrl}` + "doc/*",
					`${environment.apiUrl}` + "piano-tecnico-sanita",
					`${environment.apiUrl}` + "piano-tecnico-sanita/*",
					`${environment.apiUrl}` + "util/*",
					/* `${environment.apiUrl}`+"imprese/*",
					`${environment.apiUrl}`+"pratiche-scuola/*",
					`${environment.apiUrl}`+"pratiche-sanita/*" */
				], //, `${environment.apiUrl}`+"utente/auth0/*
			}
		}),
		TranslateModule.forRoot({
			loader: {
				provide: TranslateLoader,
				useFactory: HttpLoaderFactory,
				deps: [HttpClient],
			},
			missingTranslationHandler: {
				provide: MissingTranslationHandler,
				useClass: MyMissingTranslationHandler,
			},
		}),
		LottieModule.forRoot({player: playerFactory}),
		HomeFlowdy2DocsModule,
		DividerModule,
		OverlayPanelModule,
	],
  providers: [
    {
      provide: LocationStrategy,
      useClass: PathLocationStrategy,
    },
    { provide: 'LOCALE_ID', useValue: 'it' },
    MessageService,
    DialogService,
    VerticalAuthService,
     {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthHttpInterceptor,
      multi: true,
    }, 
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}

// required for AOT compilation
export function HttpLoaderFactory(http: HttpClient): TranslateLoader {
  return new TranslateHttpLoader(http);
}
